// Both upload entry points use the same timeout and retry identity.
export const UPLOAD_TIMEOUT_MS = 15 * 60 * 1000;
const attempts = new WeakMap<File, Map<string, string>>();
export function getUploadId(file: File, title: string, description = "", subject = ""): string {
  let requests = attempts.get(file);
  if (!requests) { requests = new Map(); attempts.set(file, requests); }
  const fingerprint = JSON.stringify([title, description, subject]);
  let id = requests.get(fingerprint);
  if (!id) { id = crypto.randomUUID(); requests.set(fingerprint, id); }
  return id;
}
